import { request } from '@/utils/request'

export function teacherStruct(params) {
  return request({
    url: '/api/bi/teacher/teacher-struct',
    method: 'get',
    params
  })
}

export function teacherAbility(params) {
  return request({
    url: '/api/bi/teacher/teacher-ability',
    method: 'get',
    params
  })
}

export function lectureAnalyse(params) {
  return request({
    url: '/api/bi/teacher/lecture-analyse',
    method: 'get',
    params
  })
}

export function examineAnalyse(params) {
  return request({
    url: '/api/bi/teacher/examine-analyse',
    method: 'get',
    params
  })
}
// echart  管理后台数据
export function getBiAdminData(params) {
  return request({
    url: '/api/bi/admin-data',
    method: 'get',
    params
  })
}
// echart  各类实验的参与人数-筛选项
export function geExaminePeopleCountingOption(params) {
  return request({
    url: '/api/bi/examine-people-counting-option',
    method: 'get',
    params
  })
}
// echart  各类实验的参与人数
export function getExaminePeopleCounting(params) {
  return request({
    url: '/api/bi/examine-people-counting',
    method: 'get',
    params
  })
}
// echart  教学数据分析
export function getBiLectureAnalyse(params) {
  return request({
    url: '/api/bi/lecture-analyse',
    method: 'get',
    params
  })
}
// echart  课件数量占比
export function getBiLessonCountRate(params) {
  return request({
    url: '/api/bi/lesson-count-rate',
    method: 'get',
    params
  })
}
// echart  备课使用最多的资源排名
export function getBiPplResRank(params) {
  return request({
    url: '/api/bi/ppl-res-rank',
    method: 'get',
    params
  })
}
// echart  资源数据
export function getBiResData(params) {
  return request({
    url: '/api/bi/res-data',
    method: 'get',
    params
  })
}
// echart  最受欢迎资源排名
export function getBiResHotRank(params) {
  return request({
    url: '/api/bi/res-hot-rank',
    method: 'get',
    params
  })
}
// echart  老师开课占比
export function getBiTeacherLectureRate(params) {
  return request({
    url: '/api/bi/teacher-lecture-rate',
    method: 'get',
    params
  })
}
// echart  老师播控占比
export function getBiTeacherOpenResRate(params) {
  return request({
    url: '/api/bi/teacher-open-res-rate',
    method: 'get',
    params
  })
}
// echart  老师备课占比
export function getBiTeacherPplRate(params) {
  return request({
    url: '/api/bi/teacher-ppl-rate',
    method: 'get',
    params
  })
}

export function teachingAbility(params) {
  return request({
    url: '/api/bi/teacher/teaching-ability',
    method: 'get',
    params
  })
}

// 理论考核列表
export function getExamineList(params) {
  return request({
    url: '/t-examine-api/groupexam/getPage',
    method: 'get',
    params
  })
}

// 实验考核列表
export function getExperimentExamineList(params) {
  return request({
    url: '/api/experiment/examine/list',
    method: 'get',
    params
  })
}

// 教学班数据
export function getClassStatisticsData(params) {
  return request({
    url: '/api/bi/data/class-statistics',
    method: 'get',
    params
  })
}

// 实验成绩数据
export function getExperimentScoreData(params) {
  return request({
    url: '/api/bi/data/experiment-score-statistics',
    method: 'get',
    params
  })
}

// 实验基础数据
export function getExperimentBasicsData(params) {
  return request({
    url: '/api/bi/data/experiment-statistics',
    method: 'get',
    params
  })
}

// 课程基础数据
export function getLessonBasicsData(params) {
  return request({
    url: '/api/bi/data/lesson-base-statistics',
    method: 'get',
    params
  })
}

// 课程数据
export function getLessonStatisticsData(params) {
  return request({
    url: '/api/bi/data/lesson-statistics',
    method: 'get',
    params
  })
}

// 试题数据
export function getQuestionStatisticsData(params) {
  return request({
    url: '/api/bi/data/question-statistics',
    method: 'get',
    params
  })
}

// 理论考核数据
export function getTheoryStatisticsData(params) {
  return request({
    url: '/api/bi/data/theory-examine-statistics',
    method: 'get',
    params
  })
}
